export const marketQuiz = {
    // Клик на кнопку "Подобрать корм"
    marketQuizClickFood: {
        rbmail: {
            type: 'click',
            id: '99370846',
        },
    },
    // Клик на кнопку "Подобрать лакомство"
    marketQuizClickTreats: {
        rbmail: {
            type: 'click',
            id: '99370847',
        },
    },
    // Подобрать корм dog
    marketQuizClickFoodDog: {
        rbmail: {
            type: 'click',
            id: '99370848',
        },
    },
    // подобрать корм cat
    marketQuizClickFoodCat: {
        rbmail: {
            type: 'click',
            id: '99370849',
        },
    },
    // Реко корм dog
    marketQuizFoodResultDog: {
        rbmail: {
            type: 'click',
            id: '99370861',
        },
    },
    // Реко корм cat
    marketQuizFoodResultCat: {
        rbmail: {
            type: 'click',
            id: '99370863',
        },
    },
    // повторить тест
    marketQuizRetest: {
        rbmail: {
            type: 'click',
            id: '99370864',
        },
    },
    // Клик на карточку товара из реко корм dog
    marketQuizClickFoodResultDog: {
        rbmail: {
            type: 'click',
            id: '99370865',
        },
    },
    // Клик на карточку товара из реко корм cat
    marketQuizClickFoodResultCat: {
        rbmail: {
            type: 'click',
            id: '99370866',
        },
    },
    // Подобрать лакомство dog
    marketQuizClickTreatsDog: {
        rbmail: {
            type: 'click',
            id: '99370867',
        },
    },
    // Подобрать лакомство cat
    marketQuizClickTreatsCat: {
        rbmail: {
            type: 'click',
            id: '99370868',
        },
    },
    // Клик на карточку товара из реко лакоство dog
    marketQuizClickTreatsResultDog: {
        rbmail: {
            type: 'click',
            id: '99370878',
        },
    },
    // Клик на карточку товара из реко лакомство cat
    marketQuizClickTreatsResultCat: {
        rbmail: {
            type: 'click',
            id: '99370879',
        },
    },
};
